import { render } from "./PrivateLayout.vue?vue&type=template&id=5d811211&scoped=true"
import script from "./PrivateLayout.vue?vue&type=script&lang=js"
export * from "./PrivateLayout.vue?vue&type=script&lang=js"

import "./PrivateLayout.vue?vue&type=style&index=0&id=5d811211&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d811211"]])

export default __exports__